import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export const PendingPage: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-6 font-sans text-slate-100">
      <div className="bg-slate-900 max-w-md w-full rounded-3xl shadow-2xl overflow-hidden text-center border border-white/[0.08]">
        <div className="bg-amber-500/10 p-8 border-b border-amber-500/20">
          <div className="w-16 h-16 bg-amber-500/20 text-amber-400 border border-amber-500/30 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg shadow-amber-500/20">
            <svg className="w-8 h-8 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-amber-500/20 border border-amber-500/40 text-amber-400 text-xs font-bold rounded-full mb-2">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse"></span>
            <span>MANUAL REVIEW IN PROGRESS</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white">Approval Pending</h2>
        </div>
        
        <div className="p-8 space-y-6">
          <p className="text-slate-300 text-sm leading-relaxed">
            Hi <strong className="text-white font-semibold">{user?.name || 'there'}</strong>, your credential registration has been successfully logged and is currently in verification queue.
          </p>
          <div className="p-4 bg-[#090d16] border border-white/[0.08] rounded-2xl text-left text-xs space-y-1.5 text-slate-400">
            <div className="font-bold text-white flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-400"></span>
              Identity & KYC Verification
            </div>
            <p className="text-[11px] leading-relaxed">
              Standard review time is under 12 hours. A Verisure administrator will review your uploaded documents and activate your verified badge.
            </p>
          </div>

          <button 
            onClick={handleLogout}
            className="w-full bg-white/5 hover:bg-white/10 text-slate-300 hover:text-white font-bold py-3.5 px-4 rounded-2xl border border-white/10 transition text-sm"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};
